export default {
    name: "FF Sea Export",
    meta: {
        icon: "directions_boat",
        expanded: true,
        auth: true
    },
    departmentName: "Sea Freight",
    finalPagePermision: "Sea Export",
    children: [
        {
            name: "FF CTT Dashboard",
            path: "/tracking/ff-ocean-insights",
            permissionName: 'FF CTT Dashboard',
            keywords: ['FF CTT Dashboard'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ocean-insights/containerTrack.vue"),
            finalPagePermision: "FF CTT Dashboard",
        },
        {
            name: "FCL/LCL Export Details ",
            path: "/freightForward/ViewffExportFcl",
            permissionName: 'Sea Export',
            keywords: ['FF Sea Export', 'FCL', 'LCL', 'FCL/LCL Details ', 'Sea Export'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/freightForwarding/ViewffExportFcl.vue"),
            finalPagePermision: "Sea Export",
        },

        // {
        //   name: "Freight Container Details ",
        //   path: "/freightForward/mergeFreightContainers",
        //   meta: {
        //     auth: true
        //   },
        //   component: require("../component/freightForwarding/mergeFreightContainers.vue"),
        //   finalPagePermision: "Sea Export",
        // },

        // {
        //   name: " Normal Sea Export Booking Details ",
        //   path: "/freightForward/viewFCLBooking",
        //   meta: {
        //     auth: true
        //   },
        //   component: require("../component/freightForwarding/viewFCLBooking.vue"),
        //   finalPagePermision: "Sea Export",
        // },
        {
            name: "FF Consolidation Prerequisite ",
            path: "/ffExportCon/viewFFPrerequisite",
            permissionName: 'Sea Export',
            keywords: ['FF Sea Export', 'FCL', 'LCL', 'Consolidation Details ', 'Sea Export', 'Prerequisite'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/Prerequisite/PrerequisiteList.vue"),
            finalPagePermision: "Sea Export",
        },
        {
            name: "FF Consolidation Export Details ",
            path: "/ffExportCon/viewFFConsoExport",
            permissionName: 'Sea Export',
            keywords: ['FF Sea Export', 'FCL', 'LCL', 'Consolidation Details ', 'Sea Export'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/ffExportCon/viewFFConsoExport.vue"),
            finalPagePermision: "Sea Export",
        },
        {
            name: "Freight Export Reports",
            path: "/Freight/freightReports",
            permissionName: 'Sea Export',
            keywords: ['FF Sea Export', 'FCL', 'LCL', 'Freight Reports ', 'Sea Export'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/reports/freightReports.vue"),
            finalPagePermision: "",
        },
        {
            name: "FF Export Billing Report",
            path: "/Freight/ffExportBillingReport",
            permissionName: 'Sea Export',
            keywords: ['FF Sea Export', 'Billing Report', 'Export Billing'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/reports/ffExportBillingReport.vue"),
            finalPagePermision: "",
        },
        {
            name: "BL Pendency",
            path: "/Freight/bl-pendency",
            permissionName: 'BL Pendency',
            keywords: ['FF Sea Export', 'FCL', 'LCL', 'Freight Reports ', 'Sea Export', 'BL List', 'BL Pendency'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/blFreight/blPendencySheet.vue"),
            finalPagePermision: "BL Pendency",
        },
        {
            name: "BL List",
            path: "/Freight/bl-list",
            permissionName: 'BL List',
            keywords: ['FF Sea Export', 'FCL', 'LCL', 'Freight Reports ', 'Sea Export', 'BL List'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/freightForwarding/bl-list.vue"),
            finalPagePermision: "BL List",
        },
        {
            name: "BL List Dashboard",
            path: "/freight/bl-dash",
            permissionName: 'BL List',
            keywords: ['FF Sea Export', 'FCL', 'LCL', 'Freight Reports ', 'Sea Export', 'BL List'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/dashboard/blListDash.vue"),
            finalPagePermision: "BL List",
        },
        {
            name: "Common BL Dash",
            path: "/freight/common-bl-dash",
            permissionName: 'BL List',
            keywords: ['FF Sea Export', 'FCL', 'LCL', 'Freight Reports ', 'Sea Export', 'BL List'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/Pendency/Tab.vue"),
            finalPagePermision: "BL List",
        },
        {
            name: "Milestone Subscription Track Dash",
            path: "/freight/milestone-tracking",
            permissionName: 'BL List',
            keywords: ['FF Sea Export', 'FCL', 'LCL', 'Freight Reports ', 'Sea Export', 'BL List'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/tracking/Tab.vue"),
            // component: require("../component/tracking/milestoneTrack.vue"),
            finalPagePermision: "BL List",
        },
        {
            name: "Milestone Subscription Track Table Dash",
            path: "/freight/milestone-tracking-table",
            permissionName: 'BL List',
            keywords: ['FF Sea Export', 'FCL', 'LCL', 'Freight Reports ', 'Sea Export', 'BL List'],
            meta: {
                icon: "directions_boat",
                auth: true
            },
            component: require("../component/tracking/milestoneTrackTable.vue"),
            finalPagePermision: "BL List",
        },
        {
            name: "TAT Dashboard",
            path: "/freight/tat-dashboard",
            permissionName: 'ULIP',
            keywords: ['TAT Dashboard', 'Turn Around Time', 'Job TAT', 'ULIP TAT'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/ulip/TATDashboard.vue"),
            finalPagePermision: "",
        },
        // {
        //     name: "BL Subscription List",
        //     path: "/freight/bl-subs-list",
        //     permissionName: 'BL List',
        //     keywords: ['FF Sea Export', 'FCL', 'LCL', 'Freight Reports ', 'Sea Export', 'BL List'],
        //     meta: {
        //         icon: "directions_boat",
        //         auth: true
        //     },
        //     component: require("../component/blFreight/blSubsListPending.vue"),
        //     finalPagePermision: "BL List",
        // },

        // {
        //   name: "Conso-Sea Export Booking Details ",
        //   path: "/ffExportCon/viewConsoBooking",
        //   meta: {
        //     auth: true
        //   },
        //   component: require("../component/ffExportCon/viewFclConsoBookingDetail.vue"),
        //   finalPagePermision: "Sea Export",
        // },
        // {
        //   name: "Conso-Sea Export Execution Details ",
        //   path: "/ffExportCon/viewConExecDetail",
        //   meta: {
        //     auth: true
        //   },
        //   component: require("../component/ffExportCon/viewConExecDetail.vue"),
        //   finalPagePermision: "Sea Export",
        // },



    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/freightForwarding.js